import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '@/store'

// TODO: Remove this
// import Form from '@/utils/forms/Form'


// Containers
import DefaultContainer from '@/containers/DefaultContainer'
// Views
// import Dashboard from '@/views/Dashboard/index'
import Dashboard from '@/readynet/dashboard'
// import Colors from '@/views/theme/Colors'
// import Typography from '@/views/theme/Typography'
// import Charts from '@/views/Charts'
// import Widgets from '@/views/Widgets'


// Views - Components
// import Cards from '@/views/base/Cards'
// import Forms from '@/views/base/Forms'
// import Switches from '@/views/base/Switches'
// import Tables from '@/views/base/Tables'
// import Tabs from '@/views/base/Tabs'
// import Breadcrumbs from '@/views/base/Breadcrumbs'
// import Carousels from '@/views/base/Carousels'
// import Collapses from '@/views/base/Collapses'
// import Jumbotrons from '@/views/base/Jumbotrons'
// import ListGroups from '@/views/base/ListGroups'
// import Navs from '@/views/base/Navs'
// import Navbars from '@/views/base/Navbars'
// import Paginations from '@/views/base/Paginations'
// import Popovers from '@/views/base/Popovers'
// import ProgressBars from '@/views/base/ProgressBars'
// import Tooltips from '@/views/base/Tooltips'

// Views - Buttons
// import StandardButtons from '@/views/buttons/StandardButtons'
// import ButtonGroups from '@/views/buttons/ButtonGroups'
// import Dropdowns from '@/views/buttons/Dropdowns'
// import BrandButtons from '@/views/buttons/BrandButtons'

// Views - Icons
// import Flags from '@/views/icons/Flags'
// import FontAwesome from '@/views/icons/FontAwesome'
// import SimpleLineIcons from '@/views/icons/SimpleLineIcons'
// import CoreUIIcons from '@/views/icons/CoreUIIcons'

// Views - Notifications
// import Alerts from '@/views/notifications/Alerts'
// import Badges from '@/views/notifications/Badges'
// import Modals from '@/views/notifications/Modals'



// Views - Pages
import Page404 from '@/views/pages/Page404'
import Page500 from '@/views/pages/Page500'
import Login from '@/views/pages/Login'
import Register from '@/views/pages/Register'

// Users
import Users from '@/views/users/Users'
import User from '@/views/users/User'

//Login Component
import LoginComponent from '@/views/LoginComponent'
// TODO Passowrd forgot and reset componenet
//Error
import PageNotFound from '@/views/PageNotFound'
//TODO: Remove this. Extras Bazan
import Vuetable from '@/views/xtras/Vuetable'




import Devicestable from '@/readynet/devices/Devicestable'
import EditDevice from '@/readynet/devices/EditDevices'
import AddDevice from '@/readynet/devices/DeviceForm'

// import Home from "@/readynet/devices/Home";
// import Contact from "@/readynet/devices/Contact";


import Configstable from '@/readynet/configs/Configstable'
import EditConfig from '@/readynet/configs/EditConfigs'
// import Configstable from '@/readynet/configs/Configstable'
import AddConfig from '@/readynet/configs/ConfigForm'

import Accountstable from '@/readynet/accounts/Accountstable'
import EditAccount from '@/readynet/accounts/EditAccounts'
import AddAccount from '@/readynet/accounts/AccountForm'

import Userstable from '@/readynet/users/Userstable'
import EditUser from '@/readynet/users/EditUsers'
import AddUser from '@/readynet/users/UserForm'

Vue.use(VueRouter);
// window.Form = Form;

const routes = [
    {
        path: '/login',
        name: 'login',
        component: LoginComponent
    },
    {
        path: '/',
        redirect: { name: 'login' },
        name: 'Home',
        component: DefaultContainer,
        meta: { requiresAuth: true },
        children: [
            {
                path: 'dashboard',
                name: 'Dashboard',
                component: Dashboard
            },


            // {
            //   path: 'users',
            //   meta: { label: 'Users'},
            //   component: {
            //     render (c) { return c('router-view') }
            //   },
            //   children: [
            //     {
            //       path: '',
            //       component: Users,
            //     },
            //     {
            //       path: ':id',
            //       meta: { label: 'User Details'},
            //       name: 'User',
            //       component: User,
            //     },
            //   ]
            // },

        ]
    },

    // {
    //     path: '/extras',
    //     redirect: '/extras/vuetable',
    //     name: 'Extras',
    //     component:DefaultContainer,
    //     meta: { requiresAuth: true },
    //     children: [
    //         {
    //         path: 'vuetable',
    //         name: 'Vuetable',
    //         component: Vuetable
    //         }
    //     ]
    // },

    {
        path: '/devices',
        redirect: '',
        name: 'Devices',
        component:DefaultContainer,
        meta: { requiresAuth: true },
        children: [
            {
            path: '/devices',
            name: 'Device List',
            component: Devicestable
            },
            {
            path: '/device/:id',
            name: 'Edit Device',
            component: EditDevice
            },
            {
            path: '/device/',
            name: 'Add Device',
            component: AddDevice
            }
        ]
    },

    {
        path: '/configs',
        redirect: '/configs',
        name: 'Configs',
        component:DefaultContainer,
        meta: { requiresAuth: true },
        children: [
            {
            path: '/configs',
            name: 'List',
            component: Configstable
            },
            {
            path: '/config/:id',
            name: 'Edit Config',
            component: EditConfig
            },
            {
            path: '/config/',
            name: 'Add Config',
            component: AddConfig
            }
        ]
    },


    {
        // beforeEnter: (to, from, next) => {

        //     if(0){
        //         next() // changes route
        //     }
        //     else{
        //         next(false) // doesn't allow changing route, you can also do redirects here etc.
        //     }
        //   },

        path: '/users',
        redirect: '/',
        name: 'Users',
        component:DefaultContainer,
        meta: { requiresAuth: true },
        children: [
            {
            path: '/users',
            name: 'Users List',
            component: Userstable
            },
            {
            path: '/user/:id',
            name: 'Edit User',
            component: EditUser
            },
            {
            path: '/user/',
            name: 'Add User',
            component: AddUser
            }
        ]
    },

    {
        path: '/accounts',
        redirect: '/',
        name: 'Accounts',
        component:DefaultContainer,
        meta: { requiresAuth: true },
        children: [
            {
            path: '/accounts',
            name: 'Accounts List',
            component: Accountstable
          },
          {
            path: '/accounts/:id',
            name: 'Edit Account',
            component: EditAccount
          },
          {
            path: '/account/',
            name: 'Add Account',
            component: AddAccount
          }
        ]
    },




    {
        path: "*",
        component: PageNotFound
    }
]

const router = new VueRouter({
    routes
})
router.beforeEach((to, from, next) => {
  if(to.matched.some(record => record.meta.requiresAuth)) {
    if (store.getters.authStatus == 'success') {
      next()
      return
    }
    next({ name: 'login' })
  } else {
    next()
  }
  if(to.path === '/login' && store.getters.authStatus == 'success') {
        next({ name: 'Dashboard' })
        return
    }

    // if(to.path === '/users'){
    //     console.log('path is : /users');
    //     next(false)
    // }
})
export default router
